export default {
  parsingNeeded() {
    return !!window.document.querySelector('body.page-category');
  },
  parse() {
    return {};
  },
};
